import { Grid, MenuItem, Select, SelectChangeEvent, Tab, Table, TableBody, Typography } from "@mui/material";
import * as api from "api/Core";
import { DefaultListParameters } from "assets/appConfig";
import { AppMessageBox } from "components/AppMessageBox";
import { AppTabs } from "components/AppTabs";
import IconButtonCancel from "components/Buttons/IconButtonCancel";
import IconButtonDownload from "components/Buttons/IconButtonDownload";
import { SpinnerIndicator } from "components/CallServer";
import { exportToXLSX } from "components/ExportToExcel";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiPagination from "components/MuiExtras/MuiPagination";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import MuiReverse from "components/MuiExtras/Typography/MuiReverse";
import { Formaters } from "lib/Formarters";
import HtmlUtils from "lib/HtmlUtils";
import LibUtils from "lib/LibUtils";
import { DashboardCourseAnalysisDetailColumn, DashboardGraphModel, DashboardPublicationModel, DashboardTopicModel, DashboardUserEnrollModel, DashboardUserModel, PagedResult } from "models/ApiModels";
import moment from "moment";
import * as React from "react";
import { WithTranslation } from "react-i18next";
import PublicationListDrawer from "views/Dashboards/components/PublicationListDrawer";
import { RenderBarGraph } from "views/Dashboards/components/RenderBarGraph";
import { RenderGraphGmtInfo } from "views/Dashboards/components/RenderGraphGmtInfo";
import { RenderLineGraph } from "views/Dashboards/components/RenderLineGraph";
import { RenderPublicationModelList } from "views/Dashboards/components/RenderPublicationModelList";
import { RenderTopicModelList } from "views/Dashboards/components/RenderTopicModelList";
import { RenderUserEnrollModelList } from "views/Dashboards/components/RenderUserEnrollModelList";
import { RenderUserModelList } from "views/Dashboards/components/RenderUserModelList";
import UserListDrawer from "views/Dashboards/components/UserListDrawer";
import { DashboardCourseAnalysisGraphPeriod, DashboardCourseAnalysisListPeriod, IDashboardCourseAnalysisGraphProps, IDashboardCourseAnalysisGraphState, IDashboardCourseAnalysisListProps } from "views/Dashboards/CourseAnalysisDashboard/Common";
import { ParticipationListPublicationPeriod } from "views/Dashboards/UserAndGroupsDashboard/Common";

/////////////////////////////////////////////////////////////////////////////////////

type DashboardCourseAnalysisEnrollmentsGraphProps = IDashboardCourseAnalysisGraphProps & WithTranslation;

export class DashboardCourseAnalysisEnrollmentsGraph extends React.PureComponent<DashboardCourseAnalysisEnrollmentsGraphProps, IDashboardCourseAnalysisGraphState>{

    constructor(props: DashboardCourseAnalysisEnrollmentsGraphProps) {
        super(props);

        this.state = {
            data: null,
            loading: true,
            selectedDay: null,
            tabOption: DashboardCourseAnalysisGraphPeriod.Last30
        };
    }

    ///
    private getDateFilter() {

        var de = moment().utc().endOf("day");
        var ds = moment().utc().startOf("day");
        ds = this.state.tabOption == DashboardCourseAnalysisGraphPeriod.Last30
            ? ds.add(-29, "days")
            : ds.add(-12, "months");

        return { startDate: ds.toDate(), endDate: de.toDate() };
    }

    ///
    private loadData() {
        api.getDashboardCourseAnalysis({
            columnToSummary: this.props.tile,
            detailColumn: this.state.tabOption == DashboardCourseAnalysisGraphPeriod.Last30 ? DashboardCourseAnalysisDetailColumn.GraphByDay : DashboardCourseAnalysisDetailColumn.GraphByMonth,
            ...this.getDateFilter(),
            ...this.props.filter,
            range: null,
        })
            .then((result) => {
                (result as DashboardGraphModel[]).forEach((v) => {
                    v.day = v.day.convertLocalToUtcDate();
                });

                this.setState({ data: (result as DashboardGraphModel[]), loading: false });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false });
            });
    }
    
    private checkForUpdateState(prevProps: DashboardCourseAnalysisEnrollmentsGraphProps) {
        if (!LibUtils.isEqual(this.props.filter, prevProps.filter)) {
            this.loadData();
        }
        else if (this.props.tile != prevProps.tile) {
            this.setState({ selectedDay: null, tabOption: DashboardCourseAnalysisGraphPeriod.Last30 }, () => this.loadData());
        }
    }

    ///
    public componentDidMount() {
        this.loadData();
    }

    ///
    public componentDidUpdate(prevProps: DashboardCourseAnalysisEnrollmentsGraphProps) {
        this.checkForUpdateState(prevProps);
    }

    ///
    public render() {
        const { tile } = this.props;
        const { loading, data } = this.state;

        if (loading)
            return <SpinnerIndicator />;

        if (data == null)
            return <AppMessageBox resource="LoadGraphDataFailed" />;

        return (
            <>
                <MuiContainer margin="dense" >
                    <Grid container justifyContent="space-between">
                        <Grid item>
                            <Typography component="p" variant="h6"><b>{this.props.t("Views.Dashboards.CourseAnalysis.AnalysisEnrollments.HeaderTitle").toString().toLocaleUpperCase()}</b></Typography>
                            <MuiMuted>
                                <small>
                                    <RenderGraphGmtInfo />
                                </small>
                            </MuiMuted>
                        </Grid>

                        <Grid item>
                            <AppTabs
                                value={this.state.tabOption}
                                onChange={
                                    (e, newValue: DashboardCourseAnalysisGraphPeriod) => {
                                        this.setState({ tabOption: newValue, selectedDay: null }, () => this.loadData());
                                    }
                                }
                                indicatorColor="primary"
                                textColor="primary"
                            >
                                <Tab label={this.props.t<string>("Views.Dashboards.Common.Days30")} value={DashboardCourseAnalysisGraphPeriod.Last30} />
                                <Tab label={this.props.t<string>("Views.Dashboards.Common.Months12")} value={DashboardCourseAnalysisGraphPeriod.Last12} />
                            </AppTabs>
                        </Grid>
                    </Grid>
                </MuiContainer>


                {
                    this.state.tabOption == DashboardCourseAnalysisGraphPeriod.Last30
                        ? <RenderLineGraph color="blue" data={this.state.data} onSelectDay={(dt) => this.setState({ selectedDay: dt })} />
                        : <RenderBarGraph color="blue" data={this.state.data} lastItemFade={0.6} onSelectDay={(dt) => this.setState({ selectedDay: dt })} />
                }

                <DashboardCourseAnalysisEnrollmentsList
                    {...this.props}
                    tile={tile}
                    selectedDay={this.state.selectedDay}
                    graphPeriod={this.state.tabOption}
                    onCancelDay={() => this.setState({ selectedDay: null })}
                />
            </>
        );
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////

interface TIListState {
    dialog: any;
    data: PagedResult<any>;
    offset: number;
    loading: boolean;
    listOption: DashboardCourseAnalysisDetailColumn;
    tabOption: DashboardCourseAnalysisListPeriod;
}

type DashboardCourseAnalysisEnrollmentsListProps = IDashboardCourseAnalysisListProps & WithTranslation;

export class DashboardCourseAnalysisEnrollmentsList extends React.PureComponent<DashboardCourseAnalysisEnrollmentsListProps, TIListState> {

    constructor(props: DashboardCourseAnalysisEnrollmentsListProps) {
        super(props);

        this.state = {
            dialog: null,
            data: null,
            offset: null,
            loading: true,
            listOption: DashboardCourseAnalysisDetailColumn.Courses,
            tabOption: DashboardCourseAnalysisListPeriod.Last30
        };
    }

    ///
    private res(r: string) {
        return this.props.t("Views.Dashboards.CourseAnalysis.AnalysisEnrollments." + r);
    }

    ///
    private loadData(offset: number, scrollToStartOfList: boolean = false) {

        this.setState({ loading: true });

        api.getDashboardCourseAnalysis(
            {
                ...this.getDateFilter(),
                columnToSummary: this.props.tile,
                detailColumn: this.state.listOption,
                range: { offset, take: DefaultListParameters.viewRecordsByPage },
                ...this.props.filter
            })
            .then((result) => {
                this.setState({ data: result, loading: false, offset: offset }, () => {
                    if (scrollToStartOfList) HtmlUtils.scrollToElement("divList");
                });

            })
            .catch((error) => {
                this.setState({ data: null, loading: false, offset: 0 });
            });
    }

    ///
    private getDateFilter() {

        if (this.props.selectedDay) {
            if (this.props.graphPeriod == DashboardCourseAnalysisGraphPeriod.Last30)
                return {
                    startDate: this.props.selectedDay.convertUtcToLocalDate(),
                    endDate: this.props.selectedDay.putEndOfDay().convertUtcToLocalDate()
                };

            if (this.props.graphPeriod == DashboardCourseAnalysisGraphPeriod.Last12) {
                let lastDay = moment(this.props.selectedDay);
                lastDay = lastDay.endOf('month');

                return {
                    startDate: this.props.selectedDay.convertUtcToLocalDate(),
                    endDate: lastDay.toDate().convertUtcToLocalDate()
                };
            }
        }

        if (this.state.tabOption == DashboardCourseAnalysisListPeriod.Last30) {

            const lastDay = moment().utc().endOf("day");
            const firstDay = moment().utc().startOf("day");
            firstDay.add(-29, "days");

            return {
                startDate: firstDay.toDate(),
                endDate: lastDay.toDate()
            };
        }

        return {
            startDate: null,
            endDate: null
        };
    }

    ///
    private handleExport = () => {

        api.getDashboardCourseAnalysis(
            {
                ...this.getDateFilter(),
                columnToSummary: this.props.tile,
                detailColumn: this.state.listOption,
                range: { offset: 0, take: 32767 },
                ...this.props.filter
            })
            .then((result) => {
                let csv: any;
                const fileName = 'CourseAnalysisEnrollments-' + moment().toISOString();

                switch (this.state.listOption) {

                    case DashboardCourseAnalysisDetailColumn.Topics:
                        csv = (result.items as DashboardTopicModel[]).map((v) => { return { name: v.name, total: v.total }; });
                        break;

                    case DashboardCourseAnalysisDetailColumn.UserEnrollment:
                        csv = (result.items as DashboardUserEnrollModel[]).map((v) => { return { name: v.name, enrolledOn: v.enrolledOn, completedOn: v.completedOn }; });
                        break;

                    case DashboardCourseAnalysisDetailColumn.UsersMostEnrollments:
                        csv = (result.items as DashboardUserModel[]).map((v) => { return { name: v.name, total: v.total }; });
                        break;

                    case DashboardCourseAnalysisDetailColumn.Courses:
                        csv = (result.items as DashboardPublicationModel[]).map((v) => { return { title: v.title, creationDate: v.creationDate, publishDate: v.publishDate, creatorName: v.creatorName, firstTopicName: v.firstTopicName, total: v.total }; });
                        break;
                }

                if (csv.length > 0) exportToXLSX(csv, fileName);

            });
    };

    ///
    private handleListOption = (e: SelectChangeEvent<DashboardCourseAnalysisDetailColumn>) => {
        this.setState({ listOption: e.target.value as DashboardCourseAnalysisDetailColumn}, () => this.loadData(0));
    };

    ///
    private getListOptions() {

        const { filter } = this.props;

        var result: Array<{ key: DashboardCourseAnalysisDetailColumn, text: string; }> = [];

        if (filter.courseId == null) {
            result.push({ key: DashboardCourseAnalysisDetailColumn.Courses, text: this.res("ListOp1") });
        }

        if (filter.topicId == null && filter.courseId == null) {
            result.push({ key: DashboardCourseAnalysisDetailColumn.Topics, text: this.res("ListOp2") });
        }

        if (filter.courseId == null) {
            result.push({ key: DashboardCourseAnalysisDetailColumn.UsersMostEnrollments, text: this.res("ListOp3") });
        }

        if (filter.courseId != null) {
            result.push({ key: DashboardCourseAnalysisDetailColumn.UserEnrollment, text: this.res("ListOp4") });
        }

        return result;
    }

    ///
    private publicationDrillDown(id: string, name: string, detailColumn: DashboardCourseAnalysisDetailColumn) {
        this.setState({
            dialog: (
                <PublicationListDrawer
                    title="Cursos"
                    subtitle={name}
                    showCreationDate={false}
                    detailCountText={{ singular: "inscrição", plural: "inscrições" }}
                    onGetData={
                        (searchtext, offset) =>
                            api.getDashboardCourseAnalysis({
                                columnToSummary: this.props.tile,
                                detailColumn: detailColumn,
                                ...this.getDateFilter(),
                                ...this.props.filter,
                                drillDownFilter: {
                                    id: id,
                                    title: searchtext,
                                },
                                range: { offset: offset, take: 20 },
                            })
                    }
                    onClose={
                        () => this.setState({ dialog: null })
                    }
                />
            )
        });
    }

    ///
    private userDrillDown(id: string, name: string, detailColumn: DashboardCourseAnalysisDetailColumn) {
        this.setState({
            dialog: (
                <UserListDrawer
                    title="Inscritos"
                    subtitle={name}
                    onGetData={
                        (searchtext, offset) =>
                            api.getDashboardCourseAnalysis({
                                columnToSummary: this.props.tile,
                                detailColumn: detailColumn,
                                ...this.getDateFilter(),
                                ...this.props.filter,
                                drillDownFilter: {
                                    id: id,
                                    title: searchtext,
                                },
                                range: { offset: offset, take: 20 },
                            })
                    }
                    onClose={
                        () => this.setState({ dialog: null })
                    }
                />
            )
        });
    }

    ///
    private renderHeader() {

        const sDay = this.props.selectedDay && this.props.graphPeriod == DashboardCourseAnalysisGraphPeriod.Last30
            ? Formaters.capitalize(this.props.t("Glossary.Day")) + " " + moment(this.props.selectedDay).format("DD/MMM")
            : this.props.selectedDay && this.props.graphPeriod == DashboardCourseAnalysisGraphPeriod.Last12
                ? moment(this.props.selectedDay).format("MMM/YYYY")
                : null;

        return (
            <div id="divList" >
                <MuiContainer margin="dense" >
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item>

                            <Select
                                value={this.state.listOption}
                                onChange={this.handleListOption}
                            >
                                {
                                    this.getListOptions().map((v, index) => <MenuItem key={index} value={v.key}>{v.text}</MenuItem>)
                                }
                            </Select>

                        </Grid>

                        <Grid item>

                            {
                                this.props.selectedDay
                                    ? (
                                        <MuiReverse color="warning">
                                            <b>{sDay}</b>
                                            <IconButtonCancel
                                                size="small"
                                                onClick={() => this.props.onCancelDay()}
                                            />
                                        </MuiReverse>
                                    )
                                    : (

                                        <AppTabs
                                            value={this.state.tabOption}
                                            onChange={
                                                (e, newValue: DashboardCourseAnalysisListPeriod) => {

                                                    this.setState({ tabOption: newValue }, () => {
                                                        this.loadData(0, true);
                                                    });

                                                }
                                            }
                                            indicatorColor="primary"
                                            textColor="primary"
                                        >
                                            <Tab label={this.props.t<string>("Views.Dashboards.Common.Days30")} value={ParticipationListPublicationPeriod.Last30} />
                                            <Tab label={this.props.t<string>("Views.Dashboards.Common.Months12")} value={ParticipationListPublicationPeriod.All} />
                                        </AppTabs>
                                    )
                            }
                        </Grid>
                    </Grid>
                </MuiContainer>
            </div>

        );
    }

    ///
    private renderListBody() {
        const { data: { items }, offset } = this.state;

        switch (this.state.listOption) {

            case DashboardCourseAnalysisDetailColumn.Topics:
                return <RenderTopicModelList
                    indexOffset={offset}
                    items={items}
                    onSelectTopic={this.props.onSelectTopic}
                    onDrillDown={(item) => this.publicationDrillDown(item.topicId, item.name, DashboardCourseAnalysisDetailColumn.TopicDrillDown)}
                />;

            case DashboardCourseAnalysisDetailColumn.UserEnrollment:
                return <RenderUserEnrollModelList
                    indexOffset={offset}
                    items={items}
                    onDrillDown={(item) => this.publicationDrillDown(item.userId, item.name, DashboardCourseAnalysisDetailColumn.UsersMostEnrollmentsDrillDown)}
                />;

            case DashboardCourseAnalysisDetailColumn.UsersMostEnrollments:
                return <RenderUserModelList
                    indexOffset={offset}
                    items={items}
                    onDrillDown={(item) => this.publicationDrillDown(item.userId, item.name, DashboardCourseAnalysisDetailColumn.UsersMostEnrollmentsDrillDown)}
                    onSelectUser={this.props.onSelectUser}
                />;


            case DashboardCourseAnalysisDetailColumn.Courses:
                return <RenderPublicationModelList
                    indexOffset={offset}
                    items={items}
                    detailCountText={{ plural: this.props.t("Views.Dashboards.Common.DetailCountCourse2"), singular: this.props.t("Views.Dashboards.Common.DetailCountCourse1") }}
                    showCreationDate={false}
                    onSelectPublication={this.props.onSelectPublication}
                    onDrillDown={(item) => this.userDrillDown(item.publicationId, item.title, DashboardCourseAnalysisDetailColumn.CoursesDrillDown)}
                />;
        }

        return null;
    }

    ///
    private renderList() {
        const { data: { total }, dialog } = this.state;

        const dataEmpty = this.res("EmptyData");

        const selectedDaySuffix =
            this.props.selectedDay && this.props.graphPeriod == DashboardCourseAnalysisGraphPeriod.Last30
                ? this.props.t("Views.Dashboards.Common.InThisDay").toLowerCase()
                : this.props.selectedDay && this.props.graphPeriod == DashboardCourseAnalysisGraphPeriod.Last12
                    ? this.props.t("Views.Dashboards.Common.InThisMonth").toLowerCase()
                    : this.props.t("Views.Dashboards.Common.InThisPeriod").toLowerCase();

        return (
            <MuiContainer margin="normal">
                <div>
                    {dialog}
                    <br />
                    {this.renderHeader()}

                    {
                        total == 0
                            ? <MuiMessageBox variant="warning" message={`${dataEmpty} ${selectedDaySuffix}`} />
                            : (
                                <>
                                    <MuiContainer>
                                        <Table size="small">
                                            <TableBody >
                                                {this.renderListBody()}
                                            </TableBody>
                                        </Table>
                                    </MuiContainer>
                                    {
                                        total > 0 &&
                                        <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs>
                                                <MuiPagination
                                                    limit={DefaultListParameters.viewRecordsByPage}
                                                    offset={this.state.offset}
                                                    total={total}
                                                    onClick={(e, offset) => this.loadData(offset, true)}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <IconButtonDownload onClick={this.handleExport} />
                                            </Grid>
                                        </Grid>
                                    }
                                </>
                            )
                    }
                </div>
            </MuiContainer >
        );
    }

    private updateListOption() {
        let listOption = this.state.listOption;
        const tiles = this.getListOptions();
        if (tiles.findIndex(p => p.key == listOption) == -1) listOption = tiles[0].key;

        this.setState({ listOption }, () => this.loadData(0));
    }

    ///
    private checkForUpdateState(prevProps: DashboardCourseAnalysisEnrollmentsListProps, prevState: TIListState) {
        if (
            !LibUtils.isEqual(this.props.filter, prevProps.filter)
            ||
            (this.props.selectedDay !== prevProps.selectedDay)
            ||
            this.props.tile !== prevProps.tile
            ||
            this.props.graphPeriod !== prevProps.graphPeriod
        ) {
            this.updateListOption();
        }
    }

    ///
    public componentDidMount() {
        this.updateListOption();
    }

    ///
    public componentDidUpdate(prevProps: DashboardCourseAnalysisEnrollmentsListProps, prevState: TIListState) {
        this.checkForUpdateState(prevProps, prevState);
    }

    ///
    public render() {
        return (
            <div>
                {
                    this.state.loading
                        ? <SpinnerIndicator />
                        : this.state.data == null
                            ? <AppMessageBox resource="LoadListDataFailed" />
                            : this.renderList()
                }
            </div>
        );
    }
}